declare const window: any;

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID || 'XXXXXXX';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageView = (url: string) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
interface EventOpt {
  action: string;
  category: string;
  label: string;
  value: number | string;
}

export const event = ({ action, category, label, value }: EventOpt) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
